import type { GraphQLError } from 'graphql';

import { expVal } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';

import useIsSmartFoldersEnabledQueryNode, {
	type useIsSmartFoldersEnabledQuery$data,
	type useIsSmartFoldersEnabledQuery$variables,
} from './__generated__/useIsSmartFoldersEnabledQuery.graphql.ts';
import useSmartFolderAncestorSyncQueryNode, {
	type useSmartFolderAncestorSyncQuery$data,
	type useSmartFolderAncestorSyncQuery$variables,
} from './__generated__/useSmartFolderAncestorSyncQuery.graphql.ts';

type PreloadSmartFolderDataOptions = {
	contentId?: string | null;
	spaceKey?: string | null;
	isRovoEnabled: boolean;
};

export const preloadSmartFolderData = ({
	contentId,
	spaceKey,
	isRovoEnabled,
}: PreloadSmartFolderDataOptions): Promise<
	| void
	| Error[]
	| (
			| {
					data: useIsSmartFoldersEnabledQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: useSmartFolderAncestorSyncQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
	  )[]
> => {
	if (
		!contentId ||
		!spaceKey ||
		!isRovoEnabled ||
		expVal<number>('confluence_smart_folders_milestone', 'value', 0) < 2
	) {
		return Promise.resolve([]);
	}

	return waitForAllReturnWhenError([
		query<useIsSmartFoldersEnabledQuery$data, useIsSmartFoldersEnabledQuery$variables>({
			query: useIsSmartFoldersEnabledQueryNode,
			variables: { spaceKey },
		}),
		query<useSmartFolderAncestorSyncQuery$data, useSmartFolderAncestorSyncQuery$variables>({
			query: useSmartFolderAncestorSyncQueryNode,
			variables: { contentId },
		}),
	]);
};
